import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment/moment";
import { toast } from "react-toastify";
import axios from "axios";

import { CouponContainer } from "../styled/dashboard";

import TabMenu from "./tabMenu";
import NotData from "./notData";
import { useMediaQuery } from "react-responsive";
import UseApp from "../../../../../common/useApp";

const Coupon = () => {
  const [coupons, setCoupons] = useState({ use: [], noUse: [] });
  const [code, setCode] = useState("");
  const [active, setActive] = useState(0);
  const [tabs, setTabs] = useState([
    { label: "보유 쿠폰", key: "noUse", status: "사용전", length: 0 },
    { label: "사용 쿠폰", key: "use", status: "사용완료", length: 0 },
  ]);
  const [isUseApp, setIsUseApp] = useState(false);

  const isMobile = useMediaQuery({ query: "(max-width:767px)" });

  const user = useSelector((state) => state?.user?.data[0]);

  useEffect(() => {
    const isUseAppPrompt = sessionStorage.getItem("hideUseApp");

    if (!isUseAppPrompt) {
      setIsUseApp(true);
    }

    getCoupon();
  }, []);

  const getCoupon = async () => {
    const url = "/erp/getUserCoupons";
    const body = { mberNo: user.mberNo };

    try {
      const res = await axios.post(url, body);
      if (res.status === 200) {
        const data = res.data?.reduce(
          (acc, item) => {
            acc[item.isUsed ? "use" : "noUse"].push(item);
            return acc;
          },
          { use: [], noUse: [] },
        );

        console.log(data);
        setCoupons(data);
        setTabs((tab) => tab.map((item) => ({ ...item, length: data[item.key].length })));
      }
    } catch (error) {
      console.log(error);
    }
  };
  const tabChange = (idx) => {
    setActive(idx);
  };

  // 쿠폰 등록
  const registerCoupon = async () => {
    const url = "/erp/registerUserCoupon";
    const body = { code, mberNo: user.mberNo };

    try {
      const res = await axios.post(url, body);
      if (res.status === 200) {
        toast.success("쿠폰이 등록되었습니다.");
        await getCoupon();
        setCode("");
      }
    } catch (error) {
      const message = error?.response?.data?.error?.[0]?.message || "잘못된 쿠폰 번호입니다.";
      toast.error(message);
    }
  };

  const status = {
    BOTH: "웹/앱",
    ONLYAPP: "앱",
    ONLYWEB: "웹",
  };

  return (
    <CouponContainer>
      {isUseApp && isMobile && (
        <UseApp
          setIsUseApp={setIsUseApp}
          message={{
            title: "한 번의 클릭으로\n더 편리하게!",
            info: "쿠폰 사용은 앱에서만 이용 가능합니다",
          }}
        />
      )}
      <div className="form">
        <input
          type="text"
          placeholder="쿠폰 번호를 입력해주세요."
          onChange={(e) => setCode(e.target.value)}
          value={code}
          onKeyDown={(e) => handleEnterKey(e, registerCoupon)}
        />
        <button onClick={() => registerCoupon()}>쿠폰 등록</button>
      </div>
      <TabMenu active={active} tabs={tabs} tabChange={tabChange} className="sub" />
      {coupons[tabs[active].key] && coupons[tabs[active].key].length > 0 ? (
        <ul className="coupon">
          <li className="header">
            <div className="image"></div>
            <span className="name">쿠폰명/쿠폰혜택</span>
            <span className="status">사용상태</span>
            <span className="type">플랫폼</span>
            <span className="desc">설명</span>
            <span className="date">{active === 0 ? "사용가능기간" : "사용일"}</span>
          </li>
          {coupons[tabs[active].key].map((item) => (
            <li>
              <div className="image">
                <img src="/img/lg.png" alt="lg" />
              </div>
              <div className="name">
                <strong>{item?.couponCode?.couponInfo?.name}</strong>
                {/* <span>3000원 할인</span> */}
              </div>
              <span className="status">{tabs[active].status}</span>
              <span className="type">{status[item?.couponCode?.couponInfo?.platform]}</span>
              <span className="desc">{item?.couponCode?.couponInfo?.description}</span>
              <span className="date">
                {active === 0
                  ? `${moment(item?.couponCode?.couponInfo?.startDate).format(
                      "YYYY.MM.DD",
                    )} ~ ${moment(item?.couponCode?.couponInfo?.endDate).format("YYYY.MM.DD")}`
                  : moment(item.usedAt).format("YYYY.MM.DD HH:mm")}
              </span>
            </li>
          ))}
        </ul>
      ) : (
        <NotData message={`${tabs[active].label}이 존재하지 않습니다.`} />
      )}
    </CouponContainer>
  );
};

export default Coupon;
